import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["addResourceBundle"];
import { useTranslation } from '@crehana/i18n';
import locales from "../i18n";
import { PAGE_ERROR_I18N_COMPONENT_KEY } from "../i18n/constants";
var useTranslationsError = function useTranslationsError() {
  var _useTranslation = useTranslation(PAGE_ERROR_I18N_COMPONENT_KEY),
    addResourceBundle = _useTranslation.addResourceBundle,
    rest = _objectWithoutProperties(_useTranslation, _excluded);
  addResourceBundle(locales);
  return rest;
};
export default useTranslationsError;